export const siteConfig = {
  name: 'po18官网',
  tagline: '海量小说，尽在掌中',
  description: 'po18官网app是广受用户喜爱的阅读平台，提供海量小说资源与优质阅读体验。',
  url: 'https://po18.com/',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/xuanhuan' },
  { label: '使用指南', href: '/article/guide-1' },
  { label: '关于我们', href: '/about' },
];

export const features = [
  {
    icon: 'ri-book-read-line',
    title: '海量书库',
    description: '涵盖玄幻、言情、都市、科幻等数十种热门分类，百万本正版小说资源，每日更新不断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '流畅阅读',
    description: '专业阅读引擎，支持字体调整、背景切换、夜间模式，打造极致舒适的阅读体验。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '离线下载',
    description: '支持一键离线下载，无网络也能畅快阅读，随时随地享受阅读乐趣。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '个性化推荐',
    description: '基于智能算法，根据您的阅读偏好精准推荐好书，发现更多精彩内容。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '互动社区',
    description: '书评、弹幕、打赏互动，与百万书友一起探讨剧情，分享阅读心得。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全正版',
    description: '官方正版授权，严格内容审核，保障阅读安全，让您放心畅读。',
  },
];

export const hotNovels = [
  {
    id: 1,
    title: '九天星辰诀',
    author: '风凌天下',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20novel%20cover%20featuring%20a%20mystical%20ancient%20Chinese%20warrior%20in%20flowing%20robes%20standing%20atop%20a%20mountain%20peak%20under%20a%20starry%20night%20sky%20with%20golden%20energy%20swirling%20around%20him%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20clean%20plain%20background%20with%20subtle%20gradient&width=400&height=560&seq=novel-cover-01&orientation=portrait',
    rating: 9.6,
    readers: '1280万',
    description: '少年持星辰之力，踏九天之路，成就无上传奇！',
  },
  {
    id: 2,
    title: '一世倾城',
    author: '苏小暖',
    category: '言情',
    cover: 'https://readdy.ai/api/search-image?query=A%20romance%20novel%20cover%20with%20a%20graceful%20ancient%20Chinese%20woman%20in%20elegant%20silk%20hanfu%20dress%20among%20cherry%20blossom%20petals%20floating%20in%20soft%20warm%20light%2C%20dreamy%20ethereal%20atmosphere%2C%20soft%20pink%20and%20cream%20tones%2C%20clean%20minimal%20background&width=400&height=560&seq=novel-cover-02&orientation=portrait',
    rating: 9.5,
    readers: '960万',
    description: '倾城之恋，跨越山河岁月，只为与你相遇。',
  },
  {
    id: 3,
    title: '都市超级医圣',
    author: '断桥残雪',
    category: '都市',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20novel%20cover%20showing%20a%20young%20man%20in%20a%20white%20coat%20standing%20in%20a%20futuristic%20cityscape%20with%20neon%20lights%20and%20glass%20buildings%2C%20medical%20symbols%20subtly%20glowing%2C%20warm%20amber%20and%20soft%20teal%20accents%2C%20clean%20modern%20design&width=400&height=560&seq=novel-cover-03&orientation=portrait',
    rating: 9.3,
    readers: '850万',
    description: '一针定生死，妙手回春的都市传奇。',
  },
  {
    id: 4,
    title: '星辰变',
    author: '我吃西红柿',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20xianxia%20novel%20cover%20depicting%20a%20celestial%20dragon%20made%20of%20starlight%20spiraling%20through%20the%20cosmos%20with%20planets%20and%20nebula%20in%20the%20background%2C%20majestic%20scale%2C%20golden%20and%20indigo%20color%20scheme%2C%20epic%20fantasy%20art%20style%2C%20clean%20gradient%20backdrop&width=400&height=560&seq=novel-cover-04&orientation=portrait',
    rating: 9.7,
    readers: '1520万',
    description: '星辰变化，万物归宗，掌控天地之力！',
  },
  {
    id: 5,
    title: '总裁的替身前妻',
    author: '忆锦',
    category: '言情',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20romance%20novel%20cover%20featuring%20a%20sophisticated%20woman%20in%20a%20designer%20white%20dress%20standing%20by%20a%20floor-to-ceiling%20window%20overlooking%20a%20city%20skyline%2C%20warm%20sunset%20lighting%2C%20elegant%20and%20refined%20aesthetic%2C%20soft%20coral%20and%20cream%20tones&width=400&height=560&seq=novel-cover-05&orientation=portrait',
    rating: 9.1,
    readers: '720万',
    description: '替身归来，她不再是那个任人摆布的女人。',
  },
  {
    id: 6,
    title: '万古神帝',
    author: '飞天鱼',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20novel%20cover%20showing%20an%20ancient%20emperor%20on%20a%20throne%20made%20of%20jade%20and%20gold%20surrounded%20by%20floating%20ancient%20runes%20and%20mystical%20energy%2C%20grand%20palace%20hall%20background%2C%20warm%20golden%20light%2C%20regal%20atmosphere&width=400&height=560&seq=novel-cover-06&orientation=portrait',
    rating: 9.8,
    readers: '2100万',
    description: '万古岁月，神帝归来，再战九天十地！',
  },
];

export const downloadSteps = [
  {
    step: 1,
    title: '访问官方网站',
    description: '通过本页面提供的官方下载入口，确保下载的是正版po18官网app。',
    icon: 'ri-global-line',
  },
  {
    step: 2,
    title: '选择对应版本',
    description: '根据您的手机系统，选择安卓版（APK）或苹果版（App Store）下载。',
    icon: 'ri-smartphone-line',
  },
  {
    step: 3,
    title: '安装并注册',
    description: '下载完成后安装应用，使用手机号或邮箱注册账号即可开始阅读。',
    icon: 'ri-user-add-line',
  },
  {
    step: 4,
    title: '畅享阅读',
    description: '登录后即可浏览海量书库，挑选心仪小说，开启阅读之旅。',
    icon: 'ri-book-open-line',
  },
];

export const faqData = [
  {
    question: 'po18官网app是否免费？',
    answer: 'po18官网app提供大量免费小说资源，部分精品内容需要付费或开通VIP会员。新用户注册即可获得免费阅读时长，让您充分体验阅读乐趣。',
  },
  {
    question: '如何下载po18官网app最新版？',
    answer: '您可以通过本页面提供的官方下载入口获取最新版本。安卓用户可直接下载APK安装包，苹果用户在App Store搜索"po18"即可找到官方应用。建议始终从官方渠道下载以确保安全。',
  },
  {
    question: 'po18官网app支持哪些设备？',
    answer: 'po18官网app全面支持安卓手机、安卓平板、iPhone和iPad设备。同时，您也可以通过网页版在电脑上阅读，实现多端同步，随时随地畅享阅读。',
  },
  {
    question: '下载的小说可以离线阅读吗？',
    answer: '是的，po18官网app支持离线下载功能。您可以将喜欢的小说下载到本地，在没有网络的环境下也能畅快阅读。下载的小说存储在应用内，不会占用额外空间。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过App内的"我的-联系客服"功能与在线客服沟通，也可以发送邮件至我们的官方客服邮箱。我们的客服团队7×24小时为您提供专业服务。',
  },
  {
    question: 'po18官网app付费内容如何退款？',
    answer: '如遇付费内容质量问题或误操作购买，您可以在购买后7天内通过App内客服渠道申请退款。我们的客服团队会及时处理您的退款请求，保障您的消费权益。',
  },
];